<script setup lang="ts">
  import { computed } from 'vue'
  import SidebarInner from './SidebarInner.vue'
  import { Sheet, SheetContent } from '@/components/ui/sheet'
  import { useAppStore } from '@/stores/app'
  import { useLocale } from '@/composables/useLocale'

  const store = useAppStore()
  const { isRTL } = useLocale()
  const isMobile = computed(() => store.isMobile)
  const sheetSide = computed(() => (isRTL.value ? 'right' : 'left'))
</script>

<template>
  <div>
    <!-- Desktop Sidebar -->
    <SidebarInner class="hidden lg:block" />

    <!-- Mobile Sidebar (Sheet/Drawer) -->
    <Sheet
      :open="store.sidebarExpanded && isMobile"
      @update:open="(val) => !val && store.toggleSidebar()"
    >
      <SheetContent :side="sheetSide" class="p-0 w-[280px] bg-transparent" :show-close="false">
        <SidebarInner class="!fixed !w-[280px]" />
      </SheetContent>
    </Sheet>
  </div>
</template>
